module.exports = __webpack_public_path__ + "media/bootstrap-icons/exclamation-square-7e09857a.svg";